<template>
  <RawVisualization
    :server-url="serverUrl"
    :series-uid="seriesUid"
    :study-uid="studyUid"
    height="100%"
  >
  </RawVisualization>
</template>

<script>
import RawVisualization from "@/components/slide/RawVisualization";
export default {
  props: {
    serverUrl: String,
    seriesUid: String,
    studyUid: String
  },
  components: { RawVisualization }
};
</script>

<style scoped></style>
